import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  pagination: {
    '&.MuiPagination-root': {
      marginTop: 40,
      display: 'flex',
      justifyContent: 'center',
    },
  },
}));

export default useStyles;
